import { render, staticRenderFns } from "./FormulaListCenter.vue?vue&type=template&id=593baf8a&scoped=true"
import script from "./FormulaListCenter.vue?vue&type=script&lang=js"
export * from "./FormulaListCenter.vue?vue&type=script&lang=js"
import style0 from "./FormulaListCenter.vue?vue&type=style&index=0&id=593baf8a&prod&lang=less&scoped=true"
import style1 from "./FormulaListCenter.vue?vue&type=style&index=1&id=593baf8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593baf8a",
  null
  
)

export default component.exports